import { Action } from '@ngrx/store';



export enum AuthActionTypes {
  DEFAULTSTATE ='DEFAULTSTATE',
  REGISTER = 'REGISTER',
  REGSUCCESS  = 'REGSUCCESS',
  REGFAILURE  = 'REGFAILURE',
  LOGIN    = 'LOGIN',
  LOGSUCCESS  = 'LOGSUCCESS',
  LOGFAILURE  = 'LOGFAILURE',
  LOGOUT   = 'LOGOUT',
  LOGOUTSUCCESS   = 'LOGOUTSUCCESS',
  LOGOUTFAILURE   = 'LOGOUTFAILURE',
  TUPAS    = 'TUPAS',
  TUPAS_SUCCESS = 'TUPAS_SUCCESS',
  TUPAS_FAILURE = 'TUPAS_FAILURE'
 
}

export class Register implements Action {
  readonly type = AuthActionTypes.REGISTER;
  constructor(public payload: any) {}
}
export class DefaultState implements Action {
  readonly type = AuthActionTypes.DEFAULTSTATE;
  constructor(public payload: any) {}
}
export class RegSuccess implements Action {
  readonly type = AuthActionTypes.REGSUCCESS;
  constructor(public payload: any) {}
}


export class RegFailure implements Action {
  readonly type = AuthActionTypes.REGFAILURE;
  constructor(public payload: any) {}
}

export class Login implements Action {
  readonly type = AuthActionTypes.LOGIN;
  constructor(public payload: any) {}
}

export class LoginSuccess implements Action {
  readonly type = AuthActionTypes.LOGSUCCESS;
  constructor(public payload: any) {}
}


export class LoginFailure implements Action {
  readonly type = AuthActionTypes.LOGFAILURE;
  constructor(public payload: any) {}
}

export class Logout implements Action {
  readonly type = AuthActionTypes.LOGOUT;
  constructor(public payload: any) {}
}
export class LogoutSuccess implements Action {
  readonly type = AuthActionTypes.LOGOUTSUCCESS;
  constructor(public payload: any) {}
}
export class LogoutFailure implements Action {
  readonly type = AuthActionTypes.LOGOUTFAILURE;
  constructor(public payload: any) {}
}
export class Tupas implements Action {
  readonly type = AuthActionTypes.TUPAS;
  constructor(public payload: any) {}
}

export class TupasSuccess implements Action {
  readonly type = AuthActionTypes.TUPAS_SUCCESS;
  constructor(public payload: any) {}
}


export class TupasFailure implements Action {
  readonly type = AuthActionTypes.TUPAS_FAILURE;
  constructor(public payload: any) {}
}
export type All =
  | Register
  | RegSuccess
  | RegFailure
  | Login 
  | LoginSuccess
  | LoginFailure
  | Logout
  | LogoutSuccess
  | LogoutFailure
  | Tupas
  | TupasSuccess
  | TupasFailure 
  | DefaultState
  ;
